import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useLogout = () => {
  const { dispatch } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const response = await api("/auth/logout", { method: "POST" }, dispatch);

      dispatch({ type: "LOGOUT" });
      toast.success(response.message);
      navigate("/login");
    } catch (error) {
      toast.error("An error occurred, please try again");
    }
  };

  return { logout };
};
